

















export default {
  name: "MultiCheckbox"

  data: () ->
    option_values: []

  props: [
    'options'
    'label'
    'value'
  ]

  mounted: () ->
    componentHandler.upgradeElements @$el
    
  methods: 
    onChange: (event) ->
      @$emit 'change', @option_values
    setChecked: (el, checked) ->
      if checked
        el.MaterialCheckbox.check()
      else
        el.MaterialCheckbox.uncheck()
  watch:
    value: (val) ->
      if _.isArray val
        @option_values = val
      else if _.isNull val
        @option_values = []
      else
        @option_values = [val]
      componentHandler.upgradeElements @$el

  updated: ()->
    for label in @$refs.cbox_label
      @setChecked label, label.firstChild.checked

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/MultiCheckbox.vue